<template>
    <div>
        <div class="text-content">
            <EmptySpace :options="{ size: 'lg' }" />
            <p :class="small ? 'text-title-large text-center' : 'text-headline'">
                {{ title }}
            </p>
            <p
                v-if="description"
                class="text-paragraph text-center"
            >
                {{ description }}
            </p>
            <div v-if="loading">
                <EmptySpace :options="{ size: 'xl' }" />
                <Position x="center">
                    <Loader />
                </Position>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import components from 'widget-components'
import Loader from '@/components/Loader.vue'

const { EmptySpace, Position } = components

defineProps<{
    title: string
    description?: string
    small?: boolean
    loading?: boolean
}>()
</script>
